<template>
  <v-container fluid>
    <v-card outlined>
      <v-card-subtitle>
        Puedes <strong>buscar</strong> por número de membresía, nombre del titular, nombre del contratante, agente o
        colectividad.
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <!-- Campo de búsqueda -->
          <v-col cols="12" m="3" md="3" lg="3">
            <v-text-field clearable class="col" v-model="NombreMem" label="Titular / membresía / contratante" outlined
              dense @change="changeSearch" @keyup.enter="Buscar">
            </v-text-field>
          </v-col>
          <!-- Selector de agentes -->
          <v-col cols="12" m="2" md="3" lg="2">
            <list-agentes @agent-change="changeAgent"></list-agentes>
          </v-col>
          <!-- Selector de colectivos y botón de descarga -->
          <v-col cols="12" m="2" md="5" lg="4">
            <select-colectivos :colectivos="colectivos" @colectivo-change="changeColectividad">
            </select-colectivos> Detalles
          </v-col>
          <!-- Botón de búsqueda -->
          <v-col>
            <v-btn color="azulfuerte" @click="Buscar" dark>
              Buscar
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-show="verOptDownloadCole">
          <v-btn color="azul_med" @click="DescargaZip" dark small class="mt-2">
            Descargar tarjetas
          </v-btn>
          <v-col>
            <p><strong>ACTIVAS: </strong> {{ this.activas }} </p>
            <p v-for="plan in this.planesUnicos" :key="plan.nombre">
              <strong>{{ plan.nombre }}: </strong> {{ plan.cantidad }}
            </p>
            <p><strong>SUSPENDIDAS: </strong>{{ this.suspendidas }}</p>
            <p><strong>BAJAS: - </strong>{{ this.totalbajas }}</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <tabla-membresias :membresias="this.contratos" :actions="tableActions"
      @action-selected="onActionSelected"></tabla-membresias>



    <pases-medicos-dialog v-show="dialogPases" ref="modalPaseMedico" :isOpen.sync="dialogPases"
      :item="this.MembresiaSelect" @crear-cita="CrearCita" @crear-cita-externa="CrearCitaExterna"
      :optPaseExt="true">
    </pases-medicos-dialog>

    <modal-list-pagos :isOpen.sync="dialogRecibos"  
    :Membresia="this.MembresiaSelect.Id || ''"></modal-list-pagos>

    <v-dialog v-model="dialogBeneficiados" max-width="80%" persistent>
      <v-card>
        <v-card-title class="text-h6">Beneficiarios: {{ this.MembresiaSelect.Id }}</v-card-title>
        <v-card-text>
          <list-beneficiarios :membresia="this.MembresiaSelect?.Id || ''"></list-beneficiarios>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogBeneficiados = false">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  computed: {
    mem() {
      return this.$route.params.mem;
    }
  },
  components: {
    SelectColectivos: () => import('@/components/selectColectivo.vue'),
    ListAgentes: () => import('@/components/selectAgenteComponent.vue'),
    TablaMembresias: () => import('@/components/tableMembresias.vue'),
    ListBeneficiarios: () => import('@/components/tableBeneficiados.vue'),
    PasesMedicosDialog: () => import('@/components/modals/PasesMedicosDialog.vue'),
    ModalListPagos: () => import('@/components/modals/ListPagoComponent.vue')
  },
  mounted() {
    this.NombreMem = this.$route.params.mem || null;
    if (this.NombreMem) {
      this.getMembresias()
    }
    this.getColectivos()
  },
  data() {
    return {
      planesUnicos: {},
      activas: 0,
      suspendidas: 0,
      totalbajas: 0,
      colectivos: [],

      dialogBeneficiados: false,
      dialogPagoShow: false,
      dialogPases: false,
      dialogRecibos: false,


      isModalCitas: false,
      
      MembresiaSelect: {},

      NombreMem: null,
      verOptDownloadCole: false,
      contratos: [],
      idagenteSelect: null,
      idcolectividadSelect: null,
      tableActions: [
        'BENEFICIADOS',
        'HISTORIAL RECIBOS',
        'PASES MEDICOS',
        'TARJETA DIGITAL',
        //'CREAR OT'
        // 'URGENCIAS',
        // 'CONTRATO'
      ],
    }
  },
  methods: {
    CrearCitaExterna(cita, callback) {
      if (!cita.Paciente || !cita.Contrato || !cita.Especialidad || !cita.MedNombres || !cita.MedApaterno) {
        this.$swal.fire({
          // position: 'top-end',
          title: 'Infomación',
          text: `Ingresa los datos requeridos.`,
          icon: 'warning',
          confirmButtonText: 'Cerrar',
          showCloseButton: false,
          // timer: 1500,
          backdrop: false,
        })
      } else {

        this.$http.post(`membresia/citamedicaexterna`, cita)
          .then(response => {
            if (response.status === 200) {
              this.colectivos = response.data
              this.actualizaNumCitas(cita.Contrato)


               this.$swal.fire({
                position: 'top-end',
                title: 'Correcto',
                text: 'Su pase médico se genero correctamente',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              })

            console.log(response.data)
            // Suponemos que result.id es el ID de la nueva cita
            const nuevoId = response.data; // result.id

            // Ejecutar callback para avisar al modal
            callback(nuevoId)
            } else {
              this.$swal.fire({
                title: 'Infomación',
                text: 'No tienes pases sificientes puedes hacer una recarga de 5 a un costo especial contacta a tu agente.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                backdrop: false
              });
            }
          })
          .catch(() => {

          })
          .finally(() => {
            // this.$refs.modalPaseMedico.reloadTable()
          });
      }
    },
    CrearCita(cita, callback) {
      if (cita.beneficiado && cita.especialidad && cita.medico.IdMedico && cita.membresia) {
        this.$http.post(`membresia/citamedica`, {
          idMem: cita.membresia,
          idEsp: cita.especialidad,
          idMed: cita.medico.IdMedico,
          idBen: cita.beneficiado
        })
          .then(response => {
            if (response.status === 200) {

              this.actualizaNumCitas(cita.membresia)
              this.$swal.fire({
                position: 'top-end',
                title: 'Correcto',
                text: 'Su pase médico se genero correctamente',
                icon: 'success',
                confirmButtonText: 'Cerrar',
                showCloseButton: false,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
                })
              // Suponemos que result.id es el ID de la nueva cita
              const nuevoId = response.data; // result.id
              // Ejecutar callback para avisar al modal
              callback(nuevoId)
            }
            else {
              this.isModalCita = false
              this.$swal.fire({
                title: 'Infomación',
                text: 'No tienes pases sificientes puedes hacer una recarga de 5 a un costo especial contacta a tu agente.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                backdrop: false
              });
            }
          })
          .catch(() => {
          })
          .finally(() => {
            //this.$refs.modalPaseMedico.reloadTable()


          });
      } else {
        this.especialidad = ''
        this.medico = ''
        this.beneficiado = ''
        this.$swal.fire({
          // position: 'top-end',
          title: 'Infomación',
          text: `Selecciona una especialidad, un médico y para quien será el pase.`,
          icon: 'warning',
          confirmButtonText: 'Cerrar',
          showCloseButton: false,
          // timer: 1500,
          backdrop: false,
        })
      }
    },
    async getColectivos() {
      this.$http.get(`colectivo/admin`)
        .then(response => {
          if (response.status === 200) {
            this.colectivos = response.data
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    changeColectividad(value) {
      this.planesUnicos = {}
      this.idcolectividadSelect = value
      this.verOptDownloadCole = value !== null;
      if (value) {
        this.idagenteSelect = null
        this.NombreMem = null
      }
    },
    changeAgent(value) {
      this.idagenteSelect = value
      if (value) {
        this.idcolectividadSelect = null
        this.NombreMem = null
      }
    },
    async getMembresias() {


      this.$http.get(`membresia?qry=${this.NombreMem || null}&idAgent=${this.idagenteSelect || null}&Colectivo=${this.idcolectividadSelect || null}`)
        .then(response => {
          if (response.status === 200) {
            this.contratos = [...response.data];  // Copiar los datos para evitar referencias directas

            this.activas = this.contratos?.filter(item => item.Estatus === 'ACTIVO').length;
            this.suspendidas = this.contratos?.filter(item => item.Estatus === 'SUSPENDIDO').length;
            this.totalbajas = this.contratos?.filter(item => item.Estatus === 'BAJA').length;
            const conteo = {};

            this.contratos?.forEach(item => {
              if (item.Plan && item.Estatus === 'ACTIVO') {
                conteo[item.Plan] = (conteo[item.Plan] || 0) + 1;
              }
            });

            this.planesUnicos = Object.entries(conteo).map(([nombre, cantidad]) => ({
              nombre,
              cantidad
            }));
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });

    },
    actualizaNumCitas(membresiaId) {
      this.$http.get(`Membresia/Numerocitas${this.MembresiaSelect.Id}`)
        .then(response => {
          if (response.status === 200) {
            const index = this.contratos.findIndex(item => item.Id === membresiaId);
            if (index !== -1) {
              this.contratos[index].NumCitas = response.data[0].NumCitas;
            }

            this.MembresiaSelect.NumCitas = response.data[0].NumCitas
            //this.MembresiaSelect.Estatus  = response.data[0].Estatus
          }
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
    DescargaZip() {
      if (this.idcolectividadSelect) {
        var urltarjet = `${process.env.VUE_APP_FORMATOS}Tarjeta/Colectividad?guid=${this.idcolectividadSelect}`;
        var newTab = window.open(urltarjet);
        if (newTab) {
          newTab.focus();
        }
      }
    },
    Buscar() {
      this.getMembresias()
    },
    changeSearch() {
      this.idcolectividadSelect = null
      this.idagenteSelect = null
    },
    onActionSelected(action, item) {
      this.MembresiaSelect = { ...item }
      switch (action) {
        case 'BENEFICIADOS':
          this.dialogBeneficiados = true
          break;
        case 'PASES MEDICOS':
          this.dialogPases = true
          break;
        case 'HISTORIAL RECIBOS':
          this.dialogRecibos = true
          break;
        case 'OT':
          this.dialogRecibos = true
          break;
        case 'TARJETA DIGITAL':
          console.log(item)
          this.$onDescargaTarjeta(item.Id)
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>